module.exports = __webpack_public_path__ + "img/Suche.122ad68a.png";